import { apiGet } from './client';

export interface SessionStats {
  total: number;
  completed: number;
  in_progress: number;
  abandoned: number;
  completion_rate: number;
}

export interface StepFunnelItem {
  step: number;
  step_name: string;
  count: number;
  percentage: number;
}

export interface SourceBreakdown {
  source: string;
  count: number;
  percentage: number;
}

export interface RecentSession {
  id: string;
  customer_id: string;
  customer_email: string;
  business_name: string;
  current_step: number;
  status: 'in_progress' | 'completed' | 'abandoned';
  source: string | null;
  created_at: string;
  updated_at: string;
  completed_at: string | null;
}

export interface OnboardingAnalyticsResponse {
  stats: SessionStats;
  funnel: StepFunnelItem[];
  by_source: SourceBreakdown[];
  recent_sessions: RecentSession[];
  avg_completion_time_hours: number | null;
}

export async function getOnboardingAnalytics(): Promise<OnboardingAnalyticsResponse> {
  return apiGet<OnboardingAnalyticsResponse>('/api/admin/onboarding-analytics');
}
